import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from '../user.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: [
    `.backdrop{
              background-color:rgba(0,0,0,0.6);
              position:fixed;
              top:0;
              left:0;
              width:100%;
              height:100vh;
}`



  ],

})
export class HeaderComponent implements OnInit {


  display = 'none';
  constructor(private router: Router, private user: UserService, private http: HttpClient) {
  }



  ngOnInit() {
  }




  loginUser(e) {
    e.preventDefault();
    const password = e.target.elements[0].value;

    if (password === 'abc') {
      this.user.setUserLoggedIn();
      this.router.navigate(['validate']);
    } else {
      alert('permission denied');
      this.onClosed();
    }
  }

  scan() {



    this.router.navigateByUrl('issues');


  }



  onClosed() {

    this.display = 'none';

  }

  openModal() {

    this.display = 'block';

  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts